<aslib-grid #grid id="grid" name="grid" headerTitle="Dados para pagamento" [(dataset)]="listaProcessado"
  indexColumnVisible="true" limit="10">
  <aslib-grid-column [property]="'id'" [visible]="false" header="id" class="text-right" [width]="1" 
  [sortable]="true" [resizable]="true"></aslib-grid-column>
  <aslib-grid-column [property]="'cnpjCpfCredor'" header="CPF/CNPJ do Credor" class="text-right" [width]="175"
    [sortable]="false" [resizable]="true">
    <ng-template #AslibGridCell let-item="item">
      <span>{{item.cnpjCpfCredor | cpf}}</span>
    </ng-template>
  </aslib-grid-column>
  <aslib-grid-column [property]="'nomeCredor'" header="Nome do Credor" class="text-left" 
    [sortable]="true" [resizable]="true"></aslib-grid-column>
    <aslib-grid-column [property]="'numeroProcessoSEI'" header="Número do Processo SEI" class="text-left" [width]="220"
    [sortable]="true" [resizable]="true">
    <ng-template #AslibGridCell let-item="item">
      <span>{{item.numeroProcessoSEI | processoSei}}</span>
    </ng-template>
  </aslib-grid-column>
    <aslib-grid-column [property]="'valorPedido'" header="Valor" class="text-right" [width]="175" 
    [sortable]="true" [resizable]="true">
    <ng-template #AslibGridCell let-item="item">
      <span>{{item.valorPedido | currency:'BRL'}}</span>
    </ng-template>
  </aslib-grid-column>
  <aslib-grid-column [property]="'numPedEmp'" header="Número do PED" class="text-right" [width]="175" 
    [sortable]="true" [resizable]="true">
  </aslib-grid-column>
  <aslib-grid-column [property]="'enviadoNoEMP'" header="Enviado" class="text-center" [width]="70"
    [sortable]="false" [resizable]="false">
    <ng-template #AslibGridCell let-item="item">
      <div *ngIf="item.enviadoNoEMP"><span class="badge badge badge-success">Sim</span></div>
      <div *ngIf="!item.enviadoNoEMP"><span class="badge badge badge-danger">Não</span></div>
    </ng-template>
</aslib-grid-column>
</aslib-grid>
<br>
<div class="form-row">
  <div class="col-md-3">
    <button (click)="enviarEMP(grid)" style="margin-top: 30px;" [disabled]="!permitirEnvio" type="submit" class="btn btn-primary"
      value="Salvar">
      <aslib-icon type="1" icon="fa fa-paper-plane"></aslib-icon>Enviar
    </button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/pagamento/empenho/processado/processado.component.html